import {VideoItem} from "../../../model/items/video";
import Player from "@vimeo/player";

class VimeoPlayer {

    show(c:VideoItem, element:Element) {

        const player = new Player(<HTMLElement>element, {
            id: <number><unknown>c.videoId,
            width: c.width,
            height: c.height,
            autoplay: c.autoPlay,
        });

        const report = (eventType: string, data?: any) => c.questionary.eventReporter?.report(eventType, data ?? `${c.videoId}`);

        // Optimistic scenario
        let ready = false;

        player.on('loaded', () => {
            report(`VIDEO_PLAYER_READY`);
            ready = true;
        });

        player.on('ended', () => {
            if (c.getFinished()) {
				return;
			}
			c.setFinished();
            report(`VIDEO_PLAYER_FINISHED_ended_event`)?.sendPending();
        });

		player.on('timeupdate', e => {
			if (c.getFinished()) {
				return;
			}
			if (e.percent >= 0.95) {
				c.setFinished();
				report(`VIDEO_PLAYER_FINISHED_timeupdate_event`)?.sendPending();
			}
		});

        // Report events
        player.on('play', () => report(`VIDEO_PLAYER_PLAY`) );
        player.on('pause', () => report(`VIDEO_PLAYER_PAUSE`) );

        // Pessimistic scenarios
        player.on('error', err => report(`VIDEO_PLAYER_ERROR`, `${c.videoId} ${err.message}`) );

        setTimeout(() => {
            if (!ready) {
                report(`VIDEO_PLAYER_ERROR`, `${c.videoId} Player is not ready after 15 s.`);
            }
        }, 15000);

        player.setVolume(1).catch(err => {
            report(`VIDEO_PLAYER_ERROR`, `${c.videoId} Volume is not set to 100%. ${err.message}`)
        });
    };

}

export var vimeoPlayer = new VimeoPlayer();
